import { render, staticRenderFns } from "./BaseEmpty.vue?vue&type=template&id=7ff4bc80&scoped=true&"
import script from "./BaseEmpty.vue?vue&type=script&lang=js&"
export * from "./BaseEmpty.vue?vue&type=script&lang=js&"
import style0 from "./BaseEmpty.vue?vue&type=style&index=0&id=7ff4bc80&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff4bc80",
  null
  
)

export default component.exports